import * as React from 'react';

import EnterpriseLearningPathSkillsDataProvider from 'bundles/enterprise-learning-path-description-page/providers/EnterpriseLearningPathSkillsDataProvider';
import UserDataProvider from 'bundles/unified-description-page-common/providers/user/UserDataProvider';

const EnterpriseLearningPathPageDataProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <EnterpriseLearningPathSkillsDataProvider>
      <UserDataProvider>{children}</UserDataProvider>
    </EnterpriseLearningPathSkillsDataProvider>
  );
};

export default EnterpriseLearningPathPageDataProvider;
